import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(18),
    flexBasis: '33.33%',
    flexShrink: 0,
    fontWeight: 500,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  
  card: {
    height: '100%',
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 17,
  },
  pos: {
    marginBottom: 12,
  },


  gridroot: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  bods: {
    fontSize: 13,
  },

  listroot: {
    width: '100%',
    
  },
  listpaper: {
    
    width: '100%',
    overflowX: 'auto',
    boxShadow: 'none',
  },
  listtable: {
    /*minWidth: 450,*/
  },

}));


const rows = [
  createData('Superchoice', '16/05/2019', '$5,000', 'Credit'),
  createData('Superchoice', '16/05/2019', '$10,000', 'Credit'),
];

function createData(name, date, amount, direction) {
  return { name, date, amount, direction };
}

function Tester() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState('panel1');

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const bull = <span className={classes.bullet}>•</span>;

  return (
    <div className={classes.root}>
      <ExpansionPanel defaultExpanded>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className={classes.heading}>Overview</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>

          <div className={classes.gridroot}>
            <Grid container spacing={3}>
              
              <Grid item xs={12} md={4}>
                <Card className={classes.card}>
                  <CardContent>
                    <Typography className={classes.title} variant="h5" component="h2">
                      Primary Contact
                    </Typography>

                    <Typography className={classes.pos} variant="body1" color="textSecondary" component="p">
                      Account Holder
                    </Typography>

                    <Typography className={classes.bods}>
                      Paul MacTier<br />
                      0433 642 846<br />
                      <a href="#">paul@selfmade.com.au</a>
                    </Typography>

                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={4}>
                <Card className={classes.card}>
                  <CardContent>
                    <Typography className={classes.title} variant="h5" component="h2">
                      Fund Structure
                    </Typography>

                    <Typography className={classes.pos} variant="body1" color="textSecondary" component="p">
                      Corporate
                    </Typography>

                    <Typography className={classes.bods}>
                      <Grid container>
                        <Grid item xs={4}>
                          Fund Name:
                        </Grid>
                        <Grid item xs={8}>
                          Coast SMSF
                        </Grid>
                        <Grid item xs={4}>
                          TFN:
                        </Grid>
                        <Grid item xs={8}>
                          Supplied
                        </Grid>
                        <Grid item xs={4}>
                          ABN:
                        </Grid>
                        <Grid item xs={8}>
                          12 619 195 005
                        </Grid>
                        <Grid item xs={4}>
                          Company Name:
                        </Grid>
                        <Grid item xs={8}>
                          Coast Pty Ltd
                        </Grid>
                        <Grid item xs={4}>
                          ACN:
                        </Grid>
                        <Grid item xs={8}>
                          619 195 005
                        </Grid>
                        <Grid item xs={4}>
                          Jurisdiction:
                        </Grid>
                        <Grid item xs={8}>
                          VIC
                        </Grid>
                      </Grid>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={4}>
                
                <Card className={classes.card}>
                  <CardContent>
                    <Typography className={classes.title} variant="h5" component="h2">
                      Fund Overview
                    </Typography>

                    <Typography className={classes.pos} variant="body1" color="textSecondary" component="p">
                      Active
                    </Typography>

                    <Typography className={classes.bods}>
                      <Grid container>
                        <Grid item xs={4}>
                          Porfolio Value:
                        </Grid>
                        <Grid item xs={8}>
                          $3,542,981.09
                        </Grid>
                        <Grid item xs={4}>
                          Asset Summery:
                        </Grid>
                        <Grid item xs={8}>
                          70% Domestic Stock
                        </Grid>
                        <Grid item xs={4}>
                        </Grid>
                        <Grid item xs={8}>
                          23% Cash
                        </Grid>
                        <Grid item xs={4}>
                        </Grid>
                        <Grid item xs={8}>
                          7% Unknown
                        </Grid>
                      </Grid>
                    </Typography>

                  </CardContent>
                  <CardActions>
                    <Button size="small">Download Report</Button>
                  </CardActions>
                </Card>

              </Grid>
            </Grid>
          </div>
          
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography className={classes.heading}>Actions</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          
          <div className={classes.gridroot}>
            <Grid container spacing={3}>
              <Grid item xs={12}>

                <Card className={classes.card}>
                  <CardContent>
                    <Typography className={classes.title} variant="h5" component="h2">
                      2 Cash Events
                    </Typography>

                    <Typography className={classes.pos} variant="body1" color="textSecondary" component="p">
                      Outstanding Unmatched Cash Events
                    </Typography>

                    <div className={classes.listroot}>
                      <Paper className={classes.listpaper}>
                        <Table className={classes.listtable} size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell></TableCell>
                              <TableCell align="right">Description</TableCell>
                              <TableCell align="right">Direction</TableCell>
                              <TableCell align="right">Amount</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.name}>
                                <TableCell component="th" scope="row">
                                  {row.date}
                                </TableCell>
                                <TableCell align="right">{row.name}</TableCell>
                                <TableCell align="right">{row.direction}</TableCell>
                                <TableCell align="right">{row.amount}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Paper>
                    </div>

                  </CardContent>
                </Card>

                    



              </Grid>

              <Grid item xs={12} md={4}>
                <Card className={classes.card}>
                  <CardContent>
                    <Typography className={classes.title} variant="h5" component="h2">
                      6 Business Events
                    </Typography>

                    <Typography className={classes.pos} variant="body1" color="textSecondary" component="p">
                      Outstanding business events must be aquired by Selfmade
                    </Typography>

                  </CardContent>
                  <CardActions>
                    <Button size="small">Request Business Events</Button>
                  </CardActions>
                </Card>
              </Grid>

              <Grid item xs={12} md={4}>
                <Card className={classes.card}>
                  <CardContent>
                    <Typography className={classes.title} variant="h5" component="h2">
                      2 Corporate Actions
                    </Typography>

                    <Typography className={classes.pos} variant="body1" color="textSecondary" component="p">
                      Outstanding Corporate Actions must be aquired by Selfmade
                    </Typography>

                  </CardContent>
                  <CardActions>
                    <Button size="small">Request Corporate Actions</Button>
                  </CardActions>
                </Card>
              </Grid>

            </Grid>
          </div>

          

        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography className={classes.heading}>Members</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit amet egestas eros,
            vitae egestas augue. Duis vel est augue.
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
        >
          <Typography className={classes.heading}>Contributions</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit amet egestas eros,
            vitae egestas augue. Duis vel est augue.
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel6bh-content"
          id="panel6bh-header"
        >
          <Typography className={classes.heading}>Reports</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit amet egestas eros,
            vitae egestas augue. Duis vel est augue.
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel7bh-content"
          id="panel7bh-header"
        >
          <Typography className={classes.heading}>Documents</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <Typography>
            Nunc vitae orci ultricies, auctor nunc in, volutpat nisl. Integer sit amet egestas eros,
            vitae egestas augue. Duis vel est augue.
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );
}

export default Tester;



// WEBPACK FOOTER //
// ./src/components/Tester/index.js